import { FieldValues } from 'interfaces/constants/CalculateModalConfig';
import { useCallback } from 'react';
import {
  DEPENDENCY_MAP,
  DependencyMapItem
} from 'utils/helpers/getDependencyMap';

export type UpdateDependentFields = (
  changedField: string,
  currentStates: FieldValues
) => FieldValues;

export const useDependencyUpdates = (): UpdateDependentFields => {
  const updateDependentFields = useCallback(
    (changedField: string, currentStates: FieldValues) => {
      const dependencies = DEPENDENCY_MAP[changedField] || { keys: [] };
      if (!dependencies.keys.length) return {};

      const dependenciesMap = new Map<string, DependencyMapItem>();

      dependencies.keys.forEach(({ dependentField, calculate }) => {
        dependenciesMap.set(dependentField, { dependentField, calculate });

        const nestedDependencies = DEPENDENCY_MAP[dependentField] || {
          keys: []
        };
        if (nestedDependencies.keys.length === 0) return;

        nestedDependencies.keys.forEach(({ dependentField, calculate }) => {
          dependenciesMap.set(dependentField, { dependentField, calculate });
        });
      });

      const tempStates = { ...currentStates };
      const newStates: FieldValues = {};

      dependenciesMap.forEach(({ dependentField, calculate }) => {
        const calculation = calculate(tempStates);
        const value = calculation ?? null;
        tempStates[dependentField] = value;
        newStates[dependentField] = value;
      });

      return newStates;
    },
    []
  );

  return updateDependentFields;
};
